import React from "react";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { RiHome6Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { TbMap2 } from "react-icons/tb";
import { VscInfo } from "react-icons/vsc";
import { languages } from "../App";
import { FiPhoneCall } from "react-icons/fi";
import { CiMail } from "react-icons/ci";

const Footer = () => {
  const { t } = useTranslation();
  const currentLangCode = cookies.get("i18next") || "en";
  const currentLang = languages.find((l) => l.code === currentLangCode);
  return (
    <div id="company" className=" tw-bg-footer-bg tw-bg-cover tw-bg-fixed">
      <div className="tw-flex tw-py-16 tw-relative tw-justify-center tw-items-center tw-group">
        <div className=" tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-z-1 tw-bg-transparent-black"></div>
        <div className="tw-static tw-z-2 tw-w-[85%] tw-px-5 lg:tw-px-5 md:tw-px-3 sm:tw-px-2 tw-mx-auto tw-py-6 tw-my-2 tw-overflow-hidden">
          <div className="tw-grid tw-grid-cols-3 lg:tw-grid-cols-1 tw-gap-6">
            <div className="tw-text-white">
              <div className="tw-flex tw-items-center">
                <span className="tw-h-[2px] tw-bg-white tw-w-[40px] "></span>
                <h1 className="tw-text-2xl md:tw-text-xl tw-p-3 tw-uppercase">
                  {t("about")}
                </h1>
              </div>
              <div className="tw-text-lg tw-tracking-wider tw-leading-8 tw-p-4 tw-shadow-md  tw-rounded-md">
                {t("about_company")}
                <p>
                  <span className="tw-text-second-gold">{t("locationIn")}</span>{" "}
                  : {t("name_company_in")}
                </p>
                <p>
                  <span className="tw-text-second-gold">
                    {t("locationOut")}
                  </span>{" "}
                  : {t("name_company_out")}
                </p>
              </div>
            </div>
            <div className="tw-text-white">
              <div className="tw-flex tw-items-center">
                <span className="tw-h-[2px] tw-bg-white tw-w-[40px] "></span>
                <h1 className="tw-text-2xl md:tw-text-xl tw-p-3 tw-uppercase">
                  {t("links")}
                </h1>
              </div>
              <div className="tw-flex tw-flex-col">
                <a
                  href="#main"
                  className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-one-gold tw-rounded-md md:tw-w-[200px] xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                >
                  <span className="tw-text-2xl sm:tw-text-xl">
                    <RiHome6Line />
                  </span>
                  <span>{t("link1")}</span>
                </a>
                <a
                  href="#comm"
                  className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-one-gold tw-rounded-md md:tw-w-[200px] xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                >
                  <span className="tw-text-2xl sm:tw-text-xl">
                    <RxDashboard />
                  </span>
                  <span>{t("link2")}</span>
                </a>
                <a
                  href="#loc"
                  className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-one-gold tw-rounded-md md:tw-w-[200px] xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                >
                  <span className="tw-text-2xl sm:tw-text-xl">
                    <TbMap2 />
                  </span>
                  <span>{t("link3")}</span>
                </a>
                <a
                  href="#company"
                  className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-p-4 tw-cursor-pointer tw-text-lg lg:tw-text-sm tw-font-semibold md:tw-font-normal xs:tw-font-thin md:tw-shadow-sm hover:md:tw-pr-7 tw-whitespace-nowrap hover:tw-bg-one-gold tw-rounded-md md:tw-w-[200px] xs:tw-text-sm tw-transition-all tw-duration-500 tw-ease-in-out"
                >
                  <span className="tw-text-2xl sm:tw-text-xl">
                    <VscInfo />
                  </span>
                  <span>{t("link4")}</span>
                </a>
              </div>
            </div>
            <div className=" tw-p-1 tw-rounded-md">
              <div className="tw-flex tw-items-center tw-text-white">
                <span className="tw-h-[2px] tw-bg-white tw-w-[40px]"></span>
                <h1 className="tw-text-2xl md:tw-text-xl tw-p-3 tw-uppercase">
                  {t("contact")}
                </h1>
              </div>

              <div>
                <h3 className="tw-text-white">{t("locationIn")}</h3>
                <div className="tw-grid tw-grid-cols-1 tw-gap-6 tw-items-center tw-mt-2 ">
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-rounded-md">
                    <span className="tw-p-3 tw-text-xl tw-text-center tw-flex tw-justify-center tw-items-center tw-text-white tw-bg-one-gold tw-rounded-full">
                      <FiPhoneCall />
                    </span>
                    <span className="tw-flex tw-flex-col">
                      <span className=" tw-font-semibold tw-text-one-gold">
                        {t("call")}
                      </span>
                      <span className="tw-text-white tw-mt-1">
                      00249123007187 – 00249912307187 {" "}
                      </span>
                    </span>
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-rounded-md">
                    <span className="tw-p-3 tw-text-xl tw-text-center tw-flex tw-justify-center tw-items-center tw-text-white tw-bg-one-gold tw-rounded-full">
                      <CiMail />
                    </span>
                    <span className="tw-flex tw-flex-col">
                      <span className=" tw-font-semibold tw-text-one-gold">
                        {t("mail")}
                      </span>
                      <span className="tw-text-white tw-mt-1">
                      ALMUNJEZCOMPANY1122@GMAIL.COM{" "}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div className=" tw-mt-5">
                <h3 className="tw-text-white">{t("locationOut")}</h3>
                <div className="tw-grid tw-grid-cols-1 tw-gap-6 tw-items-center tw-mt-2 ">
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-rounded-md">
                    <span className="tw-p-3 tw-text-xl tw-text-center tw-flex tw-justify-center tw-items-center tw-text-white tw-bg-one-gold tw-rounded-full">
                      <FiPhoneCall />
                    </span>
                    <span className="tw-flex tw-flex-col">
                      <span className=" tw-font-semibold tw-text-one-gold">
                        {t("call")}
                      </span>
                      <span className="tw-text-white tw-mt-1">
                        0097143557907 – 00971526344254{" "}
                      </span>
                    </span>
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-rounded-md">
                    <span className="tw-p-3 tw-text-xl tw-text-center tw-flex tw-justify-center tw-items-center tw-text-white tw-bg-one-gold tw-rounded-full">
                      <CiMail />
                    </span>
                    <span className="tw-flex tw-flex-col">
                      <span className=" tw-font-semibold tw-text-one-gold">
                        {t("mail")}
                      </span>
                      <span className="tw-text-white tw-mt-1">
                        MONGEZMUSTAFA@GMAIL.COM{" "}
                      </span>
                    </span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div className="tw-static tw-font-sans tw-z-3 tw-w-full tw-p-3 tw-border-t tw-border-white tw-text-white tw-flex tw-justify-center tw-items-center">
        <p>
          Copyright &copy; <span> Right Businesses</span> all rights reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
